namespace nscs.screen {

    export class MainMenuScreen extends BaseScreen {

        bg:Phaser.GameObjects.Container;
        enterCodeContainer:Phaser.GameObjects.Container;
        buttons:Phaser.GameObjects.Sprite[];
        code_txt:nscs.input.InputTextField;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bluebg0000').setOrigin(0, 0));
            let clouds = [
                new Phaser.GameObjects.Image(this.scene, 100, 185, 'ui-atlas', 'cloud0000'),
                new Phaser.GameObjects.Image(this.scene, 550, 55, 'ui-atlas', 'cloud0000').setScale(0.65).setAlpha(0.5),
                new Phaser.GameObjects.Image(this.scene, 500, 130, 'ui-atlas', 'cloud0000').setScale(0.8).setAlpha(0.75),
                new Phaser.GameObjects.Image(this.scene, 350, 20, 'ui-atlas', 'cloud0000').setScale(0.5).setAlpha(0.5)
            ];
            this.add(clouds);
            for (let c of clouds) {
                c.setOrigin(0, 0);
                c['defX'] = c.x;
                let fn = ()=>{
                    if (!this.scene) return;
                    this.scene.tweens.add({
                        targets: c,
                        x: -c.width,
                        duration: Math.random() * 10000 + 25000,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: ()=>{
                            c.x = c['defX'] + 480;
                            fn();
                        }
                    });
                };
                fn();
            }

            this.add(new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'bg_mc'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 56, 4, 'ui-atlas', 'scs_logo'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 260, 140, 'ui-atlas', 'ANI_Chickette_wholeMC'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 350, 172, 'ui-atlas', 'ANI_Nugget_wholeMC'+'0000').setOrigin(0, 0));
            this.add(new Phaser.GameObjects.Image(this.scene, 306, 160, 'ui-atlas', 'pic_c'+'0000').setOrigin(0.5, 0.5));
            this.add(new Phaser.GameObjects.Image(this.scene, 388.5,187.5, 'ui-atlas', 'pic_n'+'0000').setOrigin(0.5, 0.5));

            let scs_logo_blink = this.scene.add.sprite(275, 90, 'ui-atlas');
            scs_logo_blink.setScale(2);
            let scs_logo_blink_anim:string = 'scs_logo_blink_anim';
            if (!this.scene.anims.exists(scs_logo_blink_anim)) {
                this.scene.anims.create({
                    key: scs_logo_blink_anim,
                    frames: this.scene.anims.generateFrameNames('ui-atlas', {
                        start: 0, end: 327, zeroPad: 4,
                        prefix: 'scs_logo_blink', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }
            scs_logo_blink.play(scs_logo_blink_anim);
            this.add(scs_logo_blink);

            this.buttons = [];
            let btnKeys:string[] = ['btn_newgame', 'btn_entercode'];
            let i:number = 0;
            let btnsY:number = 195+16;
            for (let key of btnKeys) {
                let btn:Phaser.GameObjects.Sprite = nscs.scene.MainScene.instance.factory.createTypicalButton(105, btnsY + i * 33, key);
                btn.setOrigin(0, 0);
                this.buttons.push(btn);
                this.add(btn);
                btn[key==btnKeys[0]?'once':'on']('pointerup', () => {
                    if (key == 'btn_newgame') {
                        nscs.scene.MainScene.instance.resetGameplay();
                        nscs.scene.MainScene.instance.switchScreen(new nscs.screen.InstructionScreen(scene));
                        nscs.sound.SoundManager.getInstance().playSound('winnerSND');

                        sendEvent(petaGA_GameCategory_Game, 'New Game', 'Super Chick Sisters - New Game');
                    } else if (key == 'btn_entercode') {
                        this.setPamCodeEnterVisible(true);
                    }
                });
                btn.on('pointerover', () => {
                    nscs.sound.SoundManager.getInstance().playSound('coinSND', 0.5);
                });
                i++;
            }

            this.add(MainMenuScreen.createEye(290, 205, this.scene, 200));
            this.add(MainMenuScreen.createEye(320, 205, this.scene, 200));
            this.add(MainMenuScreen.createEye(370, 224, this.scene, 1100));
            this.add(MainMenuScreen.createEye(395, 227, this.scene, 1100));

            this.enterCodeContainer = new Phaser.GameObjects.Container(this.scene, 150, 235);
            this.add(this.enterCodeContainer);
            this.enterCodeContainer.visible = false;
            let e = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'enterCode_bg'+'0000');
            e.setScale(0.9);
            this.enterCodeContainer.add(e);
            e.setInteractive();
            let enterCode_btn_cancel = nscs.scene.MainScene.instance.factory.createTypicalButton(-50, 33, 'btn_cancel');
            this.enterCodeContainer.add(enterCode_btn_cancel);
            let enterCode_btn_ok = nscs.scene.MainScene.instance.factory.createTypicalButton(65, 33, 'btn_ok');
            this.enterCodeContainer.add(enterCode_btn_ok);

            let pam_label:Phaser.GameObjects.Text = this.scene.add.text(0, -37, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 10,
                "color": "#333333",
                "align": 'center'
            });
            if (nscs.gameplay.Gameplay.currentLanguage == "ES" || nscs.gameplay.Gameplay.currentLanguage == "SK") {
                pam_label.y = -45;
            }
            pam_label.setOrigin(0.5,0);
            this.enterCodeContainer.add(pam_label);
            pam_label.setWordWrapWidth(200);
            nscs.gameplay.Gameplay.setText(pam_label, 'EnterCodePrompt');
            let enterCode_txtinputbg = new Phaser.GameObjects.Image(this.scene, 0, 8, 'ui-atlas', 'enterCode_txtinputbg'+'0000');
            this.enterCodeContainer.add(enterCode_txtinputbg);

            enterCode_btn_cancel.setInteractive({cursor: 'pointer'});
            enterCode_btn_cancel.on('pointerup', this.onPamCancel);
            enterCode_btn_cancel.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND');
            });
            enterCode_btn_ok.setInteractive({cursor: 'pointer'});
            enterCode_btn_ok.on('pointerup', this.onPamOK);
            enterCode_btn_ok.on('pointerover', () => {
                nscs.sound.SoundManager.getInstance().playSound('whistleSND');
            });

            this.code_txt = new nscs.input.InputTextField(this.scene);
            this.code_txt.setPosition(-80, enterCode_txtinputbg.y);
            this.enterCodeContainer.add(this.code_txt);
        }

        private onPamCancel:()=>void = ()=>{
            this.setPamCodeEnterVisible(false);
            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
        };
        private onPamOK:()=>void = ()=>{
            let code:string = nscs.util.Functions.trim(this.code_txt.getText().toLowerCase());

            this.setPamCodeEnterVisible(false);

            let nextWorldNo:number = -1;
            switch(code) {
                case "test1":
                    nextWorldNo = 1;
                    break;
                case "test2":
                    nextWorldNo = 2;
                    break;
                case "test3":
                    nextWorldNo = 3;
                    break;
                case "test4":
                    nextWorldNo = 4;
                    break;
                case "test5":
                    nextWorldNo = 5;
                    break;
                case "test51":
                    nextWorldNo = 5.1;
                    break;
                case "gopam!":
                case "gopam":
                case "GOPAM":
                    nscs.gameplay.Gameplay.isPamLocked = false;
                    nscs.scene.MainScene.instance.playAsPam();

                    nscs.sound.SoundManager.getInstance().playSound('winnerSND');

                    sendEvent(petaGA_GameCategory_Game, 'Enter Code', 'Super Chick Sisters - Enter Code GoPam!');
                    return;
            }

            if (nextWorldNo != -1) {
                nscs.scene.MainScene.instance.resetGameplay();
                nscs.scene.MainScene.instance.setWorldsNumber(Math.floor(nextWorldNo), String(nextWorldNo));

                nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));

                nscs.sound.SoundManager.getInstance().playSound('winnerSND');
            }
        };
        public setPamCodeEnterVisible(visible:boolean):void {
            this.enterCodeContainer.visible = visible;
            for (let b of this.buttons) b.visible = !visible;
            if (visible) {
                this.code_txt.initializeInput();
            } else {
                this.code_txt.destroyInput();
            }
            this.code_txt.setText('');
        }

        public static createEye(x, y, scene, delay = 0):Phaser.GameObjects.Sprite {
            let blinking_eye = scene.add.sprite(x, y, 'ui-atlas', 'blinking_eye0000');
            let blinking_eye_anim:string = 'blinking_eye_anim';
            if (!scene.anims.exists(blinking_eye_anim)) {
                scene.anims.create({
                    key: blinking_eye_anim,
                    frames: scene.anims.generateFrameNames('ui-atlas', {
                        start: 0, end: 260, zeroPad: 4,
                        prefix: 'blinking_eye', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }
            nscs.util.Functions.delayedCall(delay, ()=>{
                if (!blinking_eye.parentContainer) return;
                blinking_eye.play(blinking_eye_anim);
            });

            return blinking_eye;
        }

        public updateScreen(): void {
            super.updateScreen();

            if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                if (this.enterCodeContainer.visible) {
                    this.setPamCodeEnterVisible(false);
                }
                nscs.scene.MainScene.instance.inputController.escPressUsed();
            } else if (nscs.scene.MainScene.instance.inputController.enterPressedDownAndReleased() && this.enterCodeContainer.visible) {
                nscs.scene.MainScene.instance.inputController.enterPressUsed();
                requestAnimationFrame(this.onPamOK);
            }
        }
    }
}
